//index bandung

import React, { useEffect, useState } from "react";
import ReactFileReader from "react-file-reader";
// material-ui
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

//icons
import People from "@material-ui/icons/People";
import BarChart from "@material-ui/icons/BarChart";
import Map from "@material-ui/icons/Map";
import Create from "@material-ui/icons/Create";
import Book from "@material-ui/icons/Book";
import Assignment from "@material-ui/icons/Assignment";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import SystemUpdateIcon from "@material-ui/icons/SystemUpdate";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import ReceiptTwoToneIcon from "@material-ui/icons/ReceiptTwoTone";

// app components
import {
  usePouchDB,
  dataBkkbn,
} from "../../../components/PouchDB/PouchDBProvider";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

//utils
//import uuidv1 from 'uuid/v1';
// styles
import useStyles from "./styles";
import { useSnackbar } from "notistack";

// images
import kb from "../../../images/kb.png";
import { useDataSync } from "../../../components/PouchDB/DataSyncProvider";

// Firebase
// import * as firebase from 'firebase';

// import { askForPermissionToReceiveNotifications } from "../../../push-notification";
import Update from "../../../UpdateAvailable";

import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import axios from "axios";
import Swal from "sweetalert2";

const CryptoJS = require("crypto-js");

function Home({ history }) {
  const API_CONFIG_URL = process.env.REACT_APP_API_CONFIG_URL;
  const classes = useStyles();
  const { user } = usePouchDB();
  const { isSyncing, isManualSyncing } = useDataSync();
  const metadata = user.metadata;
  const [wilayahkerja, setWilayahKerja] = useState("");
  const [lokus, setLokus] = useState("");
  const [targetkk, setTragetKK] = useState(0);
  const [totalDataKK, setTotalDataKK] = useState(0);
  const [totalDataKKTersimpan, setTotalDataKKTersimpan] = useState(0);
  const [totalDataKKAll, setTotalDataKKAll] = useState(0);
  const [persentase, setPersentase] = useState(0);
  const [persentaseOpsi, setPersentaseOpsi] = useState(0);
  const [pouchDB, setPouchDB] = useState(usePouchDB());
  const [backup, setBackup] = useState([]);
  const [enkripsi, setEnkripsi] = useState("");
  const [restore, setRestore] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openTotalTarget, setOpenTotalTarget] = React.useState(false);

  const [opr, setOpr] = useState(localStorage.getItem("opr"));
  const [localRw, setLocalRw] = useState(localStorage.getItem("rw"));
  const [lock, setLock] = useState(localStorage.getItem("lock"));
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );
  const [lockTarget, setLockTarget] = useState(
    localStorage.getItem("lockTarget")
  );

  const [netInfo, setNetInfo] = useState(false);
  const [isLoadingKuitansi, setIsLoadingKuitansi] = useState(false);

  //----- Check Network Online state -----//
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // useEffect(() => {
  //   console.log("metadata", metadata);
  // }, [metadata]);

  // useEffect(() => {
  //   console.log("lokus", lokus);
  // }, [lokus]);
  // useEffect(() => {
  //   console.log("wilaya kerja", wilayahkerja);
  // }, [wilayahkerja]);

  useEffect(() => {
    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen to the online status
    window.addEventListener("online", handleStatusChange);

    // Listen to the offline status
    window.addEventListener("offline", handleStatusChange);

    // Specify how to clean up after this effect for performance improvment
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]);
  //----- End Check Network Online state -----//

  //const [onloading, setOnLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar();

  const createForm = (e) => {
    // history.push(`/form`);

    if (lock === "true" || lockWilayah === "true") {
      setOpen(true);
    } else if (lockTarget === "true" || totalDataKKTersimpan >= targetkk) {
      setOpenTotalTarget(true);
    } else if (targetkk === 0) {
      setOpenTotalTarget(true);
    } else {
      history.push(`/form`);
    }
  };

  let currentPathname = null;
  let currentSearch = null;

  useEffect(() => {
    history.listen((newLocation, action) => {
      if (action === "PUSH") {
        if (newLocation.pathname !== currentPathname) {
          // simpan new location
          currentPathname = newLocation.pathname;
          currentSearch = newLocation.search;

          // clone location object and push it to history
          history.push({
            pathname: newLocation.pathname,
            search: newLocation.search,
          });
        }
      } else {
        // send user back  if they try  to navigate back
        history.go(1);
      }
    });
    // console.log(
    //   "aaaaaaaaaaaaaaaaaaa",
    //   metadata.name.substring(0, 4).toLowerCase()
    // );

    if (
      metadata.name &&
      metadata.name.substring(0, 4).toLowerCase() === "prob"
    ) {
      setTragetKK(50);
    }

    //  if (!isSyncing.syncKK) {
    if (!localStorage.getItem("notification-token")) {
      // askForPermissionToReceiveNotifications(pouchDB);
    }

    if (parseInt(metadata.tingkatwilayahid) === 5) {
      //
    } else if (parseInt(metadata.tingkatwilayahid) === 6) {
      if (metadata.wil_rw.length > 0) {
        let target_kk = 0;
        let rwName = [];
        let rtName = [];

        if (opr == "true" && localRw != "false") {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              if (parseInt(rw.id_rw) === parseInt(localRw)) {
                rw.wil_rt.forEach((rt) => {
                  rtName.push(rt.nama_rt);
                  //)
                  let targetRT = rt.targetkk;
                  if (String(rt.targetkk) == "null") {
                    //
                    targetRT = 0;
                  }

                  target_kk = target_kk + parseInt(targetRT);
                });
              }
            }
          });
        } else {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              rw.wil_rt.forEach((rt) => {
                rtName.push(rt.nama_rt);
                //)
                let targetRT = rt.targetkk;
                if (String(rt.targetkk) == "null") {
                  //
                  targetRT = 0;
                }

                target_kk = target_kk + parseInt(targetRT);
              });
            }
          });
        }

        setTragetKK(target_kk);
        // setWilayahKerja(`${metadata.wil_kelurahan.nama_kelurahan} RW:${rwName.join(',')} RT:${rtName.join(',')}`)
      }
    }
    //}

    if (metadata.wil_kelurahan.nama_kelurahan) {
      setWilayahKerja(`${metadata.wil_kelurahan.nama_kelurahan}`);
    }
    if (metadata.wil_kelurahan.lokus_verval_pk25) {
      setLokus(metadata.wil_kelurahan.lokus_verval_pk25);
      // console.log(">>>>>", metadata.wil_kelurahan.lokus_verval_pk25);
    }
  }, [metadata]);

  useEffect(() => {
    //
    if (!isSyncing.syncBkkbn) {
      let didCancel = false;
      const getAllDataKK = async () => {
        // ===== Delete local data - old doc =====
        try {
          const id_kab = metadata?.wil_kabupaten.id_kabupaten;
          //
          const resDel = await axios.get(
            API_CONFIG_URL +
              "/pk/pwaConfig/getDeleteDataByIdKabupaten?idKab=" +
              id_kab,
            {
              // headers: { user_key: USER_KEY_PG }
              headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
            }
          );

          if (resDel.data.delete === true) {
            const username = metadata?.nameProses;
            const dataLocal = await dataBkkbn.local.find({
              selector: { user_name: username },
            });

            for (let index = 0; index < dataLocal.docs.length; index++) {
              const doc = dataLocal.docs[index];

              if (
                doc.user_name === username &&
                (doc.last_update === null ||
                  !doc.hasOwnProperty("last_update") ||
                  (doc.last_update !== null &&
                    doc.last_update < resDel.data.date))
              ) {
                await dataBkkbn.local.remove(doc._id, doc._rev, function (err) {
                  if (err) {
                    return;
                  } else {
                    //
                  }
                });
              }
            }
          }
        } catch (error) {}

        // const opr = localStorage.getItem("opr");
        // const rw = localStorage.getItem("rw");

        let selector = {
          user_name: { $eq: metadata.nameProses },
        };

        if (opr == "true" && localRw != "false") {
          selector = {
            user_name: { $eq: metadata.nameProses },
            id_rw: { $eq: localRw },
          };
        }

        try {
          const query = await dataBkkbn.local.find({
            selector,
          });

          let arr = [];
          let all = [];
          let bak = [];
          let tersimpan = [];
          query.docs.forEach((item) => {
            if (item.status_sensus != "Delete") {
              if (
                item.status_sensus === "Received" ||
                item.status_sensus === "Valid" ||
                item.status_sensus === "Anomali" ||
                item.status_sensus === "Anomali Terkonfirmasi" ||
                item.status_sensus === "NotValid" ||
                (item.status_draft === "2" &&
                  (item.status_sensus === "" ||
                    item.status_sensus === "Tersimpan"))
              ) {
                // arr.push(item)
                if (item.sts_keluarga === "1" || item.sts_keluarga === "5") {
                  tersimpan.push(item);

                  if (
                    item.status_sensus !== "" &&
                    item.status_sensus !== "Tersimpan"
                  ) {
                    all.push(item);
                  }
                }
              }

              // if ((item.year_doc === '2022' && item.status_draft === '2' && item.status_sensus != '') || (item.year_doc === '2021' && item.sts_keluarga !== null)) {
            }

            bak.push(item);
          });

          if (!didCancel)
            //setTotalDataKK(arr.length)
            setTotalDataKKAll(all.length);
          setTotalDataKKTersimpan(tersimpan.length);
          setBackup(bak);
        } catch (error) {}

        //
        //
      };

      getAllDataKK();

      return () => {
        didCancel = true;
      };
    }
  }, [metadata, isSyncing.syncBkkbn, isManualSyncing]);

  useEffect(() => {
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(backup),
      process.env.REACT_APP_SECRET_KEY
    ).toString();
    //
    setEnkripsi(ciphertext);
  }, [backup]);

  useEffect(() => {
    let persent = (totalDataKKAll / targetkk) * 100;

    let persentOpsiVal = (totalDataKKAll / targetkk) * 100;
    if (targetkk == 0) {
      persent = 0;
      persentOpsiVal = 0;
    }

    if (persent > 100) {
      persent = 100;
    }
    setPersentase(persent);
    setPersentaseOpsi(persentOpsiVal);
  }, [targetkk, totalDataKKAll]);

  useEffect(() => {
    restoreFile();
  }, [restore]);

  const restoreFile = async () => {
    const data = restore;
    let _rev;
    let count = 0;
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        const cek = backup.find((item) => {
          if (data[i]._id == item._id) {
            if (item.status_sensus != "Delete") {
              return true;
            }
            return false;
          }
          return false;
        });

        if (!cek) {
          count += 1;
          try {
            if (data[i].status_sensus == "Delete") {
              let dataInsert = {
                ...data[i],
                status_sensus: "",
              };

              await dataBkkbn["local"].put(dataInsert);
            } else {
              let dataInsert = {
                ...data[i],
                status_sensus: "",
                _rev,
              };

              await dataBkkbn["local"].put(dataInsert);
            }
          } catch (error) {
            //
          }
        }
      }
      setRestore([]);
      enqueueSnackbar(count + " Data berhasil di restore ke local", {
        variant: "success",
      });
    }
  };

  const handleFiles = async (files) => {
    var reader = new FileReader();
    reader.readAsText(files[0], "UTF-8");
    reader.onload = (files) => {
      let ciphertext = files.target.result;
      try {
        var bytes = CryptoJS.AES.decrypt(
          JSON.parse(ciphertext),
          process.env.REACT_APP_SECRET_KEY
        );
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        const data = decryptedData;

        if (data.length > 0) {
          //
          if (data[0].user_name == user.metadata.name) {
            setRestore(data);
          } else {
            enqueueSnackbar("Data tidak sesuai dengan user login", {
              variant: "error",
            });
          }
        } else {
          enqueueSnackbar("Data tidak ditemukan", { variant: "error" });
        }
      } catch (error) {
        try {
          const data = JSON.parse(files.target.result);

          if (data.length > 0) {
            //
            let new_data = data.filter(
              (item) => item.user_name === user.metadata.name
            );

            if (new_data[0].user_name == user.metadata.name) {
              setRestore(new_data);
            } else {
              enqueueSnackbar("Data tidak sesuai dengan user login", {
                variant: "error",
              });
            }
          } else {
            enqueueSnackbar("Data tidak ditemukan", { variant: "error" });
          }
        } catch (error) {
          enqueueSnackbar("Data tidak sesuai", { variant: "error" });
        }

        //enqueueSnackbar("Data tidak sesuai", { variant: 'error' })
      }
    };
  };

  const handleClose = () => {
    setOpen(false);
    setOpenTotalTarget(false);
  };

  const AlertDialog = () => {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Periode pendataan untuk wilayah anda telah berakhir
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tutup
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const AlertDialogTotalTarget = () => {
    return (
      <div>
        <Dialog
          open={openTotalTarget}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Progres pendataan telah mencapai target
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tutup
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  // tambahan opsional

  // tambahan opsional

  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: persentaseOpsi > 100 ? "#f44336" : "#1a90ff",
    },
  }))(LinearProgress);

  const prosesKuitansi = async () => {
    try {
      setIsLoadingKuitansi(true);
      const opr = localStorage.getItem("opr");
      const username = metadata?.nameProses;

      //
      //
      let rk = "PENDATA";
      if (opr === "true") {
        rk = "OPR";
      }

      const urlCek =
        "https://pk23-portal-gw.bkkbn.go.id/pemutakhiran/portalpk/metodepembayaran/getStatusPembayaranAndroid?userId=" +
        metadata.id;

      const resStatusCek = await axios({
        method: "get",
        url: urlCek,
        headers: {
          Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
          "Content-Type": "application/json",
        },
        responseType: "json",
      });

      //
      //
      if (resStatusCek.data.status_pembayaran === "1") {
        Swal.fire({
          title: "Peringatan",
          text: "Kuitansi pembayaran belum bisa dicetak karena masih dalam tahap pendataan atau approval pembayaran belum diproses",
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            setIsLoadingKuitansi(false);
          }
        });
      } else if (resStatusCek.data.status_pembayaran === "2") {
        Swal.fire({
          title: "Peringatan",
          text: "Kuitansi pembayaran belum bisa dicetak karena masih dalam proses approval pembayaran",
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            setIsLoadingKuitansi(false);
          }
        });
      } else if (resStatusCek.data.status_pembayaran === "3") {
        const url =
          "https://pk23-portal-gw.bkkbn.go.id/report/viewReport?filterPencarian=%7B%22userId%22%3A%22" +
          metadata.id +
          "%22%2C%22reportName%22%3A%22KuitansiPendata2025%22%2C%22reportType%22%3A%22pdf%22%2C%22reportCategory%22%3A%22" +
          rk +
          "%22%2C%22metode%22%3A%22TUNAI%22%7D";
        //
        const resStatus = await axios({
          method: "get",
          url: url,
          headers: {
            Authorization:
              localStorage.getItem("tokenMtg") !== "null"
                ? "Bearer " + localStorage.getItem("tokenMtg")
                : "",
            Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        });

        if (resStatus.status === 200) {
          // Create a blob URL from the response data
          const blobUrl = URL.createObjectURL(new Blob([resStatus.data]));

          // Create an anchor element, 'a' is <a>
          const link = document.createElement("a");

          // Set the href attribute to the blob URL
          link.href = blobUrl;

          // Set the download attribute with the desired file name
          link.download = "Kuitansi-" + username + ".pdf";

          // Append the link to the document
          document.body.appendChild(link);

          // Trigger a click on the link to initiate the download
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);

          setIsLoadingKuitansi(false);
        } else {
          // Handle error or show a message if the request was not successful
          console.error("Failed to fetch the file:", resStatus);
          setIsLoadingKuitansi(false);
        }
      } else {
        Swal.fire({
          title: "Peringatan",
          text: "Kuitansi pembayaran belum bisa dicetak karena masih dalam tahap pendataan atau approval pembayaran belum diproses",
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            setIsLoadingKuitansi(false);
          }
        });
      }
    } catch (error) {
      //
      setIsLoadingKuitansi(false);
    }
  };

  const handleKuitansi = async () => {
    if (isOnline) {
      Swal.fire({
        title: "Kuitansi Pembayaran",
        text: "Anda akan melakukan download kuitansi pembayaran?",
        icon: "info",
        cancelButtonText: "Tidak",
        cancelButtonColor: "#d33",
        showCancelButton: true,
        confirmButtonText: "Ya",
        confirmButtonColor: "#3085d6",
      })
        .then((result) => {
          if (result.value) {
            prosesKuitansi();
          }
        })
        .catch((error) => {});
    } else {
      Swal.fire({
        title: "Peringatan",
        text: "Download kuitansi pembayaran membutuhkan koneksi internet",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
    }
  };

  function isRestrictedUser(username) {
    if (!username) return false;
    return username.substring(0, 4).toLowerCase() === "prob";
  }

  // useEffect(() => {
  //   console.log("metadata", metadata.name);
  // }, []);
  const isProbRestricted = isRestrictedUser(metadata?.name);

  return (
    <Container maxWidth="md" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <div className={classes.floatRightIcon}>
            <Map fontSize="large" />
          </div>
          <Typography variant="h5">Wilayah Kerja</Typography>
          <Typography variant="subtitle1">
            Desa/Kel: {wilayahkerja || "-"}
          </Typography>
          {opr == "true" && localRw != "false" ? (
            <>
              {metadata.wil_rw.map((rw, i) => {
                if (parseInt(rw.id_rw) === parseInt(localRw)) {
                  let rtName = [];
                  if (rw.wil_rt.length > 0) {
                    rw.wil_rt.map((rt, y) => {
                      // let RT = rt.id_rt_bkkbn + " - " + rt.nama_rt;
                      let RT = rt.nama_rt;
                      rtName.push(RT);
                    });
                  } else {
                    let name = "Tidak Ada RT";
                    rtName.push(name);
                  }
                  return (
                    // <Typography variant="subtitle1">
                    //   RW {rw.id_rw_bkkbn} - {rw.nama_rw}/RT: {rtName.join(",")}
                    // </Typography>
                    <Typography variant="subtitle1" key={i}>
                      {rw.nama_rw}: {rtName.join(",")}
                    </Typography>
                  );
                }
              })}
            </>
          ) : (
            <>
              {metadata.wil_rw.map((rw, i) => {
                let rtName = [];
                if (rw.wil_rt.length > 0) {
                  rw.wil_rt.map((rt, y) => {
                    // let RT = rt.id_rt_bkkbn + " - " + rt.nama_rt;
                    let RT = rt.nama_rt;
                    rtName.push(RT);
                  });
                } else {
                  let name = "Tidak Ada RT";
                  rtName.push(name);
                }
                return (
                  // <Typography variant="subtitle1">
                  //   RW {rw.id_rw_bkkbn} - {rw.nama_rw}/RT: {rtName.join(",")}
                  // </Typography>
                  <Typography variant="subtitle1" key={i}>
                    {rw.nama_rw}: {rtName.join(",")}
                  </Typography>
                );
              })}
            </>
          )}
          <Typography variant="subtitle1">Lokus: {lokus || "-"}</Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <div className={classes.floatRightIcon}>
            {/* <BarChart fontSize="large" /> */}
            <Typography variant="h5">
              {persentaseOpsi.toFixed(2) >= 100
                ? 100
                : persentaseOpsi.toFixed(2)}{" "}
              %
            </Typography>
          </div>
          <Typography variant="h5" style={{ marginBottom: 10 }}>
            Progress Kerja
          </Typography>
          <BorderLinearProgress variant="determinate" value={persentase} />
          <Typography variant="subtitle1">
            {totalDataKKAll} dari {targetkk} Keluarga
          </Typography>
        </Grid>

        {!isProbRestricted && (
          <Grid item xs={12}>
            <ButtonBase className={classes.fullWidth} onClick={createForm}>
              <Paper
                className={classes.blueGreyBackground}
                style={{ backgroundColor: "#4caf50", borderRadius: "8px" }}
                elevation={0}
              >
                <Typography variant="h6">
                  <Create className={classes.iconLeft} />
                  Tambah Data
                </Typography>
              </Paper>
            </ButtonBase>
          </Grid>
        )}

        <Grid item xs={12}>
          <ButtonBase
            className={classes.fullWidth}
            onClick={() => {
              history.push("/list");
            }}
          >
            <Paper
              className={classes.blueGreyBackground}
              style={{ backgroundColor: "#0288d1", borderRadius: "8px" }}
              elevation={0}
            >
              <Typography variant="h6">
                <People className={classes.iconLeft} />
                Daftar Keluarga
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ButtonBase
            className={classes.fullWidth}
            onClick={() => {
              history.push("/rekap");
            }}
          >
            <Paper
              className={classes.blueGreyBackground}
              style={{ backgroundColor: "#ff9800", borderRadius: "8px" }}
              elevation={0}
            >
              <Typography variant="h6">
                <Assignment className={classes.iconLeft} />
                Rekap RT
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ButtonBase
            onClick={() => {
              history.push("/definisi-operasional");
            }}
            className={classes.fullWidth}
          >
            <Paper
              className={classes.blueGreyBackground}
              style={{ backgroundColor: "#03a9f4", borderRadius: "8px" }}
              elevation={0}
            >
              <Typography variant="h6">
                <Book className={classes.iconLeft} />
                Definisi Operasional
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ButtonBase
            className={classes.fullWidth}
            onClick={() => {
              history.push("/list-local");
            }}
          >
            <Paper
              className={classes.blueGreyBackground}
              style={{ backgroundColor: "#9c27b0", borderRadius: "8px" }}
              elevation={0}
            >
              <Typography variant="h6">
                <AllInboxIcon className={classes.iconLeft} />
                Data Lokal
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ButtonBase className={classes.fullWidth}>
            <a
              className={classes.fullWidth}
              href={`data:text/json;charset=utf-8,${encodeURIComponent(
                JSON.stringify(enkripsi)
              )}`}
              download={
                user.metadata.name + ".txt" || user.metadata.name + ".json"
              }
            >
              <Paper
                className={classes.blueGreyBackground}
                style={{ backgroundColor: "#3f51b5", borderRadius: "8px" }}
                elevation={0}
              >
                <Typography variant="h6">
                  <SystemUpdateIcon className={classes.iconLeft} />
                  Backup As File
                </Typography>
              </Paper>
            </a>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ReactFileReader
            fileTypes={[".txt", ".json"]}
            handleFiles={handleFiles}
          >
            <ButtonBase className={classes.fullWidth}>
              <Paper
                className={classes.blueGreyBackground}
                style={{ backgroundColor: "#673ab7", borderRadius: "8px" }}
                elevation={0}
              >
                <Typography variant="h6">
                  <RestorePageIcon className={classes.iconLeft} />
                  Restore From File
                </Typography>
              </Paper>
            </ButtonBase>
          </ReactFileReader>
        </Grid>

        {isLoadingKuitansi ? (
          <>
            <Grid item xs={12} sm={6}>
              <ButtonBase className={classes.fullWidth}>
                <ButtonBase
                  className={classes.fullWidth}
                  onClick={() => handleKuitansi()}
                  download={"Kuitansi-" + user.metadata.name + ".pdf"}
                  disabled={isLoadingKuitansi}
                >
                  <Paper
                    className={classes.blueGreyBackground}
                    style={{ backgroundColor: "#228B22", borderRadius: "8px" }}
                    elevation={0}
                  >
                    <IconButton aria-label="Manual Sync" className="noOutline">
                      <CircularProgress
                        style={{ color: "white", marginRight: "10px" }}
                        size={24}
                      />
                      <Typography variant="h6">
                        Mohong tunggu sedang proses...
                      </Typography>
                    </IconButton>
                  </Paper>
                </ButtonBase>
              </ButtonBase>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={6}>
              <ButtonBase className={classes.fullWidth}>
                <ButtonBase
                  className={classes.fullWidth}
                  onClick={() => handleKuitansi()}
                  download={"Kuitansi-" + user.metadata.name + ".pdf"}
                  disabled={isLoadingKuitansi}
                >
                  <Paper
                    className={classes.blueGreyBackground}
                    style={{ backgroundColor: "#228B22", borderRadius: "8px" }}
                    elevation={0}
                  >
                    <Typography variant="h6">
                      <ReceiptTwoToneIcon className={classes.iconLeft} />
                      Kuitansi
                    </Typography>
                  </Paper>
                </ButtonBase>
              </ButtonBase>
            </Grid>
          </>
        )}
      </Grid>

      {/* update version */}
      {/* <Update /> */}
      <AlertDialog />
      <AlertDialogTotalTarget />
    </Container>
  );
}

export default Home;
